import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { captureUTMsFromURL, trackEvent } from '../lib/leads';
import { trackWhatsAppContact, trackPhoneContact } from '../lib/whatsapp';
import ConciergeChat from './ConciergeChat';
import AgendarModal from './AgendarModal';

export default function GlobalUI() {
  const [scrollProgress, setScrollProgress] = useState(0);
  const location = useLocation();

  useEffect(() => {
    captureUTMsFromURL();
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const totalScroll = document.documentElement.scrollTop;
      const windowHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      if (windowHeight > 0) setScrollProgress((totalScroll / windowHeight) * 100);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setScrollProgress(0);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Global click tracking on tel: and wa.me anchors — fires both our own
  // backend analytics event AND the Meta Pixel standard 'Contact' event.
  useEffect(() => {
    const handleClick = (e) => {
      const a = e.target.closest('a');
      if (!a) return;
      const href = a.getAttribute('href') || '';
      // Try to infer the source from the clicked element for better analytics.
      const source =
        a.getAttribute('data-testid') ||
        a.closest('[data-section]')?.getAttribute('data-section') ||
        'global';
      if (href.startsWith('tel:')) {
        trackEvent('phone_clicked', { href });
        trackPhoneContact(source);
      } else if (href.includes('wa.me') || href.includes('whatsapp.com')) {
        trackEvent('whatsapp_clicked', { href });
        trackWhatsAppContact(source);
      }
    };
    document.addEventListener('click', handleClick, { capture: true });
    return () => document.removeEventListener('click', handleClick, { capture: true });
  }, []);

  return (
    <>
      <div
        aria-hidden="true"
        style={{
          position: 'fixed', top: 0, left: 0, right: 0,
          height: '3px', zIndex: 9999,
          backgroundColor: 'rgba(6,64,96,0.10)',
          pointerEvents: 'none',
        }}
      >
        <div style={{
          width: `${scrollProgress}%`, height: '100%',
          backgroundColor: 'var(--brand-accent, #f6802c)',
          transition: 'width 0.08s linear',
        }} />
      </div>

      <ConciergeChat />
      <AgendarModal />
    </>
  );
}
